export const getHost = () => {
    return process.env.NODE_ENV === `development` ||
      document.location.href.indexOf("themewordpress") > -1
      ? "https://amadeus.holiserver.com/testapi"
      : //"http://localhost:4000/api"
        window.location.protocol + "//" + window.location.hostname + "/api";
  };
  